module.exports = __webpack_public_path__ + "img/1474967585.b59188e0.jpg";